<!--
 Created by huangw on 2020/10/16.
 柱状图
-->
<template>
  <div :id="id" :style="style"></div>
</template>

<script>
import echarts from "echarts";
import Vue from "vue";
Vue.prototype.$echarts = echarts;
export default {
  name: "echar",
  props: {
    id: {
      type: String,
    },
    style: {},
  },
  data() {
    return {
      myChart: null,
    };
  },
  mounted() {
    this.drawLine();
    window.addEventListener("resize", this.resize());
  },
  created() {
    const user = this.$ls.get("user");
  },
  beforeDestroy() {},
  methods: {
    //自适应宽度
    resize() {
      let that = this;
      let timer = null;
      return function () {
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          var myChart = that.$echarts.init(document.getElementById(that.id));
          myChart.resize();
        });
      };
    },
    refreshData(xAxisData, seriesData, axisLabel) {
      // this.myChart.showLoading({
      //   text: "数据正在加载...",
      //   textStyle: { fontSize: 30, color: "#444" },
      //   effectOption: { backgroundColor: "rgba(0, 0, 0, 0)" },
      // });
      var option = this.myChart.getOption();
      option.xAxis[0].data = xAxisData;
      option.series[0].data = seriesData;
      if (axisLabel != undefined) {
        option.xAxis[0].axisLabel = {
          show: true,
          textStyle: {
            color: "#000", //更改坐标轴文字颜色
            fontSize: 12, //更改坐标轴文字大小
          },
          rotate: 40,
          showMinLabel: true, //显示最小值
          showMaxLabel: true, //显示最大值
        };
      }
      this.myChart.setOption(option);
      // this.myChart.hideLoading();
      this.myChart.resize();
    },
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      this.myChart = this.$echarts.init(document.getElementById(this.id));

      // 绘制图表
      this.myChart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        color: "#1890ff",
        grid: {
          left: 0,
          right: 0,
          bottom: 0,
          top:20,
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: ["数据", "数据", "数据", "数据", "数据", "数据", "数据"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: [0, 0, 0, 0, 0, 0, 0],
            type: "bar",
            showBackground: true,
            backgroundStyle: {
              color: "rgba(220, 220, 220, 0.8)",
            },
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "black",
                    fontSize: 16,
                  },
                },
              },
            },
          },
        ],
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>
